<template>
    <div class="page" :class="slug ? slug : ''">
        <div class="q10__first">
            <div class="q10__intro relativ flex justify-center md:justify-start items-center" :class="'q10__' + slug + '_intro'">
                <div class="q10__intro__content px-4 text-center ml-0 md:ml-16">
                    <p v-html="currentPage.content.projectTitle.text" class="q10__intro__content__title mb-2 text-white text-3xl md:text-5xl font-bold text-center md:text-left"></p>
                    <p v-html="currentPage.content.projectSubTitle.text" class="q10__intro__content__subtitle text-flamingo text-lg md:text-xl text-center md:text-left"></p>
                </div>
            </div> 
            <div class="q10__first_section">
                <div class="container px-11 2xl:px-3 m-auto">
                    <div class="q10__first_section__paragraphs">
                        
                        <SectionVerticalTextParagpraphs
                            :options="{
                                fontSizeVerticalText: '2.5rem',
                                verticalText: currentPage.content.firstVerticalText.text
                            }"
                        >
                            
                            <Paragraph
                                :options="{
                                    color: 'text-white'
                                }"
                            >
                                <span v-html="currentPage.content.firstParagraphText.text"> </span>
                            </Paragraph>
                            <Paragraph
                                :options="{
                                    color: 'text-white'
                                }"
                            >
                            <!-- <hotspot-richmedia
                            :options="{
                                icon: 'diaporama',
                                collection: getRichmediaByCollection(
                                    currentPage,
                                    '20 ans CIH - Témoignages prestataires'
                                ),
                            }"
                            class="top-80 left-2.5 lg:left-1.5"
                        />  -->
                                <span v-html="currentPage.content.secondParagraphText.text"> </span>
                            </Paragraph>
                            
                            <Paragraph
                                :options="{
                                    color: 'text-white'
                                }"
                            >
                            
                                <span v-html="currentPage.content.thirdParagraphText.text"> </span>
                            </Paragraph>
                            
                            <Paragraph
                                :options="{
                                    color: 'text-white'
                                }"
                            >
                                <span v-html="currentPage.content.fourthParagraphText.text"> </span>
                                
                            </Paragraph>
                            <Author
                                :options="{
                                    color: 'text-white'
                                }"
                            >
                            
                                <span class="text-white" v-html="currentPage.content.fifthParagraphText.text"></span>
                            </Author>
                        </SectionVerticalTextParagpraphs>
                        
                    </div>
                    
                </div>
               
                <!-- <ScrollButton />
                <div id="scrollToNextSection"></div> -->
                
            </div>
        </div>
        
        <div class="q10__second_section">
            <div class="q10_intro_second_page"></div>
            <div class="container px-11 2xl:px-3 m-auto">
                <div class="q10__second_section__paragraphs">
                    
                    <SectionVerticalTextParagpraphs
                        :options="{
                            fontSizeVerticalText: '2.5rem',
                            verticalText: currentPage.content.secondVerticalText.text
                        }"
                    >
                        <div class="paragraphs_with_image flex flex-col md:flex-row">
                            
                                
                            
                            <div class="all_paragraphs flex flex-col">
                                <Paragraph class="flex flex-col xl:flex-row"
                                    :options="{
                                        color: 'nandor'
                                    }"
                                >
                                <div>
                                    <div class="paragraph_image w-full float-left mb-5 md:mr-40 md:pr-5 md:mb-0">
                                    <image-with-descriptions
                                        :options="{
                                            image:
                                                'pages/' +
                                                currentPage.slug +
                                                '/' +
                                                currentPage.images.image1.src,
                                        }"
                                    />
                                    </div>
                                </div>
                                    <span v-html="currentPage.content.seventhParagraphText.text"> </span>
                                </Paragraph>
                                
                                <Paragraph
                                    :options="{
                                        color: 'nandor'
                                    }"
                                >
                                    <span v-html="currentPage.content.eigthParagraphText.text"> </span>
                                </Paragraph>
                                <Paragraph
                                    :options="{
                                        color: 'nandor'
                                    }"
                                >
                                    <span v-html="currentPage.content.ninthParagraphText.text"> </span>
                                </Paragraph>
                                <Paragraph
                                    :options="{
                                        color: 'nandor'
                                    }"
                                >
                                    <span v-html="currentPage.content.tentharagraphText.text"> </span>
                                </Paragraph>
                                <Author
                                    :options="{
                                        color: 'nandor'
                                    }"
                                >
                                    <!-- <span v-html="currentPage.content.sixthParagraphText.text"></span> -->
                                </Author>
                            </div>
                        </div>
                    </SectionVerticalTextParagpraphs>
                    
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import PagesMixin from '@/mixins/PagesMixin';
    import Paragraph from '../../components/Paragraph.vue';
    import ScrollButton from "../../components/ScrollButton";

    export default {
        components: { Paragraph, ScrollButton },
        name: 'Page001',
        mixins: [PagesMixin]
    };
</script>

<style scoped lang="scss">
    .page {
        @media screen and (min-width: 1025px) {
             display: flex;
             flex-direction: row;
        }

        background: rgb(24, 48, 124);
        background: linear-gradient(180deg, rgba(24, 48, 124, 1) 30%, rgba(0, 106, 173, 1) 75%);
        
        .q10__intro{
            height: 35vh;
            text-align: start;

            @media screen and (width: 1024px) and (height: 640px) {
                height: 50vh;
            }
            @media screen and (width: 768px) and (height: 1024px) {
                height: 40vh;
            }
            @media screen and (max-width: 900px) and (orientation: landscape) {
                height: 70vh;
            }
            @media screen and (max-width: 768px) and (orientation: landscape) {
                height: 50vh;
            }
        }
        .q10_intro_second_page{
            height: 35vh;

            @media screen and (width: 1024px) and (height: 640px) {
                height: 50vh;
            }
            
            @media screen and (max-width: 900px) and (orientation: landscape) {
                height: 70vh;
            }
            @media screen and (max-width: 768px) and (orientation: landscape) {
                height: 50vh;
            }
            @media screen and (max-width: 768px) {
                height: 5vh;
            }
            @media screen and (width: 768px) and (height: 1024px) { 
                height: 40vh;
            }
        }
        .first_section {
            @media screen and (min-width: 768) {
                 width: 50%;
                 float: left;
            } 
        }

        .q10__second_section {
            @media screen and (min-width: 768) {
                 width: 50%;
                 float: right;
            }
            background-color: white;
            .paragraph_image {
                .min-w-custom {
                    min-width: 220px;
                }
            }
        }
    }
    .image-with-descriptions {
        margin: 0;
    }
    .photo_logo {
        width: 100%;

        img {
            width: 100%;
            height: 100vh;
            object-fit: cover;
        }
    }
</style>
